{
  "7d31b83313991d4c": "Notificación",
  "969ccbd3cf6300ec": "Correo electrónico",
  "9e956229d85c31df": "Error al actualizar las preferencias de notificación",
  "ca7981b46ecf2c17": "Apagar",
  "d2f8538027aed163": "Preferencias de notificación de salud en el hogar"
}
